<template>
  <v-app :key="componentKey">
    <!--  <preloader></preloader> -->
    <!--Never use keep-alive in router-view in App.vue-->

    <transition-page>
      <router-view></router-view>
    </transition-page>
  </v-app>
</template>

<script>
import { I18n } from "aws-amplify";
import { Validator } from "vee-validate";

import TransitionPage from "@/components/TransitionPage.vue";
import Preloader from "@/components/Preloader";

//import { Analytics, Auth } from "aws-amplify";

export default {
  name: "App",
  components: {
    TransitionPage,
    // eslint-disable-next-line vue/no-unused-components
    Preloader
  },
  props: {
    //Eliminar esto si más adelante no es necesario
  },
  data() {
    return {
      componentKey: 0
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    }
  },
  watch: {
    language(val) {
      I18n.setLanguage(val);
      Validator.localize(val);
      this.forceRenderer();
    }
  },
  methods: {
    //Force re-render strategy when change language
    //https://hackernoon.com/the-correct-way-to-force-vue-to-re-render-a-component-bde2caae34ad
    forceRenderer() {
      this.componentKey += 1;
    }
  },

  beforeCreate() {
    console.log(
      "App.vue beforeCreate*****************************************************************"
    );
    this.$router.push("/");

    let lang = this.$store.getters.language;
    I18n.setLanguage(lang);
    Validator.localize(lang);
  }
  /* async created() {
    Auth.currentUserInfo()
      .then(({ attributes }) => {
        const userAttributes = {};
        Object.entries(attributes).forEach(([key, value]) => {
          userAttributes[key] = [`${value}`];
        });
        Analytics.updateEndpoint({
          address: attributes.email, // Or phone_number
          channelType: "EMAIL", // Or 'SMS'
          userId: attributes.sub,
          userAttributes
        });
      })
      .then(() => console.log("Do something else"));
  } */
};
</script>
